<template>
  <ion-content id="app" class="ion-padding">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="6" offset-sm="3">
          <h1 class="ion-padding">Config bearbeiten</h1>
          <ConfigFields :id="id"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
  import ConfigFields from "../../components/config/ConfigFields";

  export default {
    name: "ConfigEdit",
    components: {ConfigFields},
    data(){
      return {
        id: this.$route.params.id
      }
    },
  };
</script>

<style scoped>
  h1 {
    color: #B6B6B6;
  }

</style>
